import type { EmbeddingConfigurationResponse, EmbeddingJob } from 'types/cms';

export const EMBEDDING_CHUNK_SIZE = 512;
export const EMBEDDING_CHUNK_OVERLAP = 8;
export const DEFAULT_VECTOR_MINIMUM_SCORE = 0.5;
export const EMBEDDING_JOB_POLL_MS = 3000;

export type EmbeddingIndexStatus = 'none' | 'indexing' | 'ready' | 'failed';

export function isVectorSearch(filter: { vectorMinimumScore?: number }) {
	return typeof filter.vectorMinimumScore === 'number';
}

export function getEmbeddingIndexStatus(data: EmbeddingConfigurationResponse | null | undefined): EmbeddingIndexStatus {
	if (!data?.configuration) return 'none';
	if (data.jobs.waiting || data.jobs.inProgress) return 'indexing';

	const latest = latestJobForVersion(data.jobs.history, data.configuration.version);
	if (latest?.status === 'completed') return 'ready';
	if (latest?.status === 'failed') return 'failed';
	return 'none';
}

export function isVectorIndexReady(data: EmbeddingConfigurationResponse | null | undefined) {
	return getEmbeddingIndexStatus(data) === 'ready';
}

export function getEmbeddingActiveJob(data: EmbeddingConfigurationResponse | null | undefined) {
	return data?.jobs.inProgress ?? data?.jobs.waiting ?? null;
}

function latestJobForVersion(history: EmbeddingJob[], version: number) {
	return history
		.filter(job => job.configurationVersion === version)
		.sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))[0];
}
